import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-social-chat',
  templateUrl: './social-chat.component.html',
  styleUrls: ['./social-chat.component.css']
})
export class SocialChatComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
